/* Автоматически генерируемый файл */
import { type ThemeSizeTokens } from '@direct-frontend/components';

/**
 * Размерные токены для подкомпонентов элемента, определяют размеры иконок, хелпов, лейблов
 *
 * Генерируется автоматически по значениям из yml файла, лучше не редактировать руками
 */
export const themeSizeTokens: ThemeSizeTokens = {
    '4xs': {
        iconSize: '8',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 2,
        paddingVCard: 2,
        paddingHIcon: 5,
        paddingHText: 5,
        paddingHUnified: 5,
        paddingHIconSquare: 4,
        paddingHCard: 5,
    },
    '3xs': {
        iconSize: '12',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 2,
        paddingVCard: 2,
        paddingHIcon: 6,
        paddingHText: 6,
        paddingHUnified: 6,
        paddingHIconSquare: 4,
        paddingHCard: 6,
    },
    '2xs': {
        iconSize: '12',
        helpSize: '12',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 4,
        paddingVCard: 4,
        paddingHIcon: 8,
        paddingHText: 8,
        paddingHUnified: 8,
        paddingHIconSquare: 6,
        paddingHCard: 8,
    },
    xs: {
        iconSize: '16',
        helpSize: '16',
        innerLabelSize: '4xs',
        outerLabelSize: '4xs',
        paddingV: 6,
        paddingVCard: 6,
        paddingHIcon: 8,
        paddingHText: 12,
        paddingHUnified: 12,
        paddingHIconSquare: 8,
        paddingHCard: 12,
    },
    s: {
        iconSize: '16',
        helpSize: '16',
        innerLabelSize: '3xs',
        outerLabelSize: '3xs',
        paddingV: 8,
        paddingVCard: 8,
        paddingHIcon: 10,
        paddingHText: 16,
        paddingHUnified: 12,
        paddingHIconSquare: 10,
        paddingHCard: 16,
    },
    m: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '3xs',
        paddingV: 10,
        paddingVCard: 14,
        paddingHIcon: 14,
        paddingHText: 20,
        paddingHUnified: 14,
        paddingHIconSquare: 10,
        paddingHCard: 20,
    },
    l: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 12,
        paddingVCard: 14,
        paddingHIcon: 14,
        paddingHText: 20,
        paddingHUnified: 16,
        paddingHIconSquare: 16,
        paddingHCard: 20,
    },
    xl: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 16,
        paddingVCard: 16,
        paddingHIcon: 24,
        paddingHText: 24,
        paddingHUnified: 24,
        paddingHIconSquare: 20,
        paddingHCard: 24,
    },
    '2xl': {
        iconSize: '24',
        helpSize: '24',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 20,
        paddingVCard: 20,
        paddingHIcon: 32,
        paddingHText: 32,
        paddingHUnified: 32,
        paddingHIconSquare: 28,
        paddingHCard: 32,
    },
    layout: {
        iconSize: '24',
        helpSize: '16',
        innerLabelSize: '2xs',
        outerLabelSize: '2xs',
        paddingV: 28,
        paddingVCard: 28,
        paddingHIcon: 24,
        paddingHText: 24,
        paddingHUnified: 36,
        paddingHIconSquare: 36,
        paddingHCard: 36,
    },
};
